import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import { NotifyBatchPanel } from "@/business/notify/NotifyBatchPanel";

/** AI 알림장 — 오늘 등원 펫 일괄 초안 생성 라우트 */
export const Route = createFileRoute("/business/layout/notify-batch")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <LayoutHeader title="AI 일괄 알림장" hasBackBtn hasFootPrint={false} />
      <div className="flex-1 min-h-0 flex flex-col bg-[#F5F5F5]">
        <div className="flex-1 min-h-0 overflow-y-auto px-4 pt-3">
          <NotifyBatchPanel />
        </div>
      </div>
    </>
  );
}
